import { render, staticRenderFns } from "./FixedIncomeContent.vue?vue&type=template&id=4b4cc67b&scoped=true"
import script from "./FixedIncomeContent.vue?vue&type=script&lang=js"
export * from "./FixedIncomeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cc67b",
  null
  
)

export default component.exports